import { ref, onUnmounted } from 'vue'

/**
 * Hook simple para polling
 * Recarga datos cada N segundos sin complicaciones
 */
export function useSSE() {
  let pollInterval = null

  const connect = (endpoint, onMessage, onError) => {
    disconnect()

    const poll = async () => {
      try {
        const response = await fetch(endpoint)
        const data = await response.json()

        if (!response.ok) {
          throw new Error(data.message || 'Error')
        }

        // Simplemente llamar el callback con los datos
        console.log('📡 Poll ejecutado - Enviando datos:', data)
        if (data.data) {
          onMessage(data.data)
        } else {
          onMessage(data)
        }
      } catch (err) {
        console.error('❌ Error en polling:', err)
      }
    }

    // Primer poll inmediato
    console.log('🚀 Iniciando SSE polling en:', endpoint)
    poll()

    // Poll cada 5 segundos (mantener datos frescos sin avances automáticos)
    pollInterval = setInterval(poll, 5000)
    console.log('⏰ Polling configurado cada 5 segundos')
  }

  const disconnect = () => {
    if (pollInterval) {
      clearInterval(pollInterval)
      pollInterval = null
    }
  }

  onUnmounted(() => {
    disconnect()
  })

  return { connect, disconnect }
}
